import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const ProductsDashboardLazy = loadable(
    () => import(/* webpackChunkName: "ProductsDashboard" */ './ProductsDashboardSuspense')
);

export const ProductsDashboardAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <ProductsDashboardLazy />
    </DelayedSuspense>
);
